const set = async ({ commit }, { visible, text = '', status = 'info' }) => {
  commit('set', { visible, text, status });
};

export default {
  set,
};
